import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import { VocStatusCode } from "@/types";
import { IVoc } from "@/domain/entities/bbs";


const __default__ = {
  name: "VocRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  voc: {
    type: Object as PropType<IVoc>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();



const vocStatusCodeMap: Record<string, string> = {
  [VocStatusCode.SUBMIT]: "submit",
  [VocStatusCode.ASSIGN]: "assign",
  [VocStatusCode.ACTIVE]: "active",
  [VocStatusCode.PAUSED]: "paused",
  [VocStatusCode.CLOSED]: "closed",
  [VocStatusCode.ANSWER]: "answer",
  [VocStatusCode.DISCAR]: "discard",
};

const __returned__ = { vocStatusCodeMap }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})